import { VIDEO_API } from "../apis/video";

const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB / chunk
const POLL_INTERVAL_MS = 2000;
const POLL_TIMEOUT_MS = 5 * 60 * 1000; // 5 phút chờ HLS

const genId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `vid-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Upload 1 video theo cơ chế chunked của BE rồi chờ xử lý HLS xong.
 * @param {File} file
 * @param {(percent:number, phase:'uploading'|'processing'|'done')=>void} onProgress
 * @returns {Promise<{ id:string, final_hls_url:string, status:string }>}
 */
export async function uploadVideoWithHls(file, { onProgress } = {}) {
    const idVideo = genId();
    const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));

    for (let i = 0; i < totalChunks; i++) {
        const start = i * CHUNK_SIZE;
        // Giữ lại MIME type (file.type) khi cắt chunk — nếu không Blob sẽ mất type
        // → multer nhận application/octet-stream → fileFilter chặn 400.
        const blob = file.slice(start, Math.min(start + CHUNK_SIZE, file.size), file.type);
        await VIDEO_API.uploadChunk(idVideo, blob, i, totalChunks);
        if (onProgress) {
            onProgress(Math.round(((i + 1) / totalChunks) * 100), "uploading");
        }
    }

    // Chờ BE merge + chuyển HLS xong (DONE) thì mới có final_hls_url.
    const startTime = Date.now();
    if (onProgress) onProgress(100, "processing");

    while (Date.now() - startTime < POLL_TIMEOUT_MS) {
        await sleep(POLL_INTERVAL_MS);
        let info;
        try {
            info = await VIDEO_API.getVideoStatus(idVideo);
        } catch (e) {
            continue; // tạm thời lỗi mạng → thử lại
        }
        const status = info?.status;
        if (status === "DONE") {
            if (onProgress) onProgress(100, "done");
            return {
                id: idVideo,
                final_hls_url: info.final_hls_url,
                status,
            };
        }
        if (status === "FAILED") {
            throw new Error("Xử lý video thất bại, vui lòng thử lại");
        }
    }

    throw new Error("Hết thời gian chờ xử lý video, vui lòng thử lại");
}
